module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/prizes-2f1bde8da36c808c2fce67bad94c6026.svg";